import { marketGuidesEnabled, whatsOnYourPlateEnabled } from 'src/app/site-config';
import { Component, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/services/registration-service';
import { Guide, GUIDES } from 'src/app/article-landing/guides';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialogModalComponent } from '../feedback-dialog-modal/feedback-dialog-modal.component';

@Component({
  selector: 'pla-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  /** Market Guides link (hosts where the series is switched on). */
  public readonly marketGuides = marketGuidesEnabled;
  /** What's on Your Plate logo, opposite the PlateX logo (off on www until approved). */
  public readonly woyp = whatsOnYourPlateEnabled;
  public currentUrl = window.location.pathname;
  public currYear = new Date(Date.now()).getFullYear();
  /** Published guides (same list as the /guides hub). */
  public readonly guides: Guide[] = GUIDES;
  public versionNo = environment.versionNo;
  public plateCount: number = Math.floor(
    Math.random() * (6820000 - 6810000 + 1) + 68000000
  );

  constructor(private registrationService: RegistrationService, private dialog: MatDialog) {
    this.registrationService
      .getPlateCount()
      .subscribe((_: { totalCount: number }) => {
        this.plateCount = _.totalCount;
      });
  }

  ngOnInit(): void { }

  /** Opens the FreePrivacyPolicy cookie preferences centre (loaded in index.html).
   *  Called directly: the script only binds #open_preferences_center once at page
   *  load, which misses a footer Angular renders later. */
  /** Footer feedback (replaces the old side tab): same form, tagged by source. */
  public openFeedback(source: string): void {
    this.dialog.open(FeedbackDialogModalComponent, {
      width: '420px',
      maxWidth: '92vw',
      data: { context: { source } },
    });
  }

  public openCookiePreferences(event: Event): void {
    event.preventDefault();
    const cc = (window as any).cookieconsent;
    if (cc && typeof cc.openPreferencesCenter === 'function') cc.openPreferencesCenter();
  }
}
